import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { FileConversionService } from '../services/file-conversion.service';
import { Router } from '@angular/router';
import { ProcessApiService } from '../services/process.api';
import { DataSharingService } from '../services/data-sharing.service';
import { switchMap, catchError, of } from 'rxjs';

@Component({
  selector: 'app-email-page',
  standalone: true,
  imports: [FormsModule, CommonModule, HeaderComponent, FooterComponent],
  templateUrl: './email-page.component.html',
  styleUrl: './email-page.component.scss'
})
export class EmailPageComponent implements OnInit {

  email: string = '';
  filename: string = '';
  isLoading: boolean = false;

  constructor(
    private fileConversionService: FileConversionService, 
    private router: Router, 
    private processApiService: ProcessApiService, 
    private dataSharingService: DataSharingService,
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit(): void {
    // Définir le titre de la page (46 caractères - optimal)
    this.title.setTitle('Saisissez votre email – pdf-to-word.fr');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Saisissez votre adresse email pour recevoir votre fichier PDF converti en Word. Service rapide et sécurisé de conversion de documents.' });
    this.meta.updateTag({ name: 'keywords', content: 'email conversion PDF Word, recevoir fichier converti, envoi email pdf-to-word, réception document Word' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Saisissez votre email – pdf-to-word.fr' });
    this.meta.updateTag({ property: 'og:description', content: 'Saisissez votre adresse email pour recevoir votre fichier PDF converti en Word. Service rapide et sécurisé de conversion de documents.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });

    // Récupérer les données depuis le service
    const conversionData = this.fileConversionService.getConversionData();
    if (conversionData && conversionData.filename) {
      this.filename = conversionData.filename.replace(conversionData.originalFormat ?? '.pdf', conversionData.targetFormat ?? '.docx');
    }
  }

  onSubmit() {
    if (this.email) {
      this.isLoading = true;

      // Créer un nouveau Lead, puis créer le Prospect une fois terminé
      this.processApiService.createLead(this.email, this.filename).pipe(
        switchMap((leadResponse) => {
          console.log('Lead créé avec succès');
          this.dataSharingService.setLeadData(leadResponse);
          
          // Créer le Prospect après la création du Lead
          return this.processApiService.createProspect(this.email, this.filename);
        }),
        catchError((error) => {
          console.error('Erreur lors de la création du lead:', error);
          return of(null);
        })
      ).subscribe({
        next: (prospectResponse) => {
          if (prospectResponse) {
            console.log('Prospect créé avec succès');
            this.dataSharingService.setProspectData(prospectResponse.data.prospect);
            this.router.navigate(['/checkout']);
          } else {
            this.router.navigate(['/progress-page']);
          }
        },
        error: (error) => {
          console.error('Erreur lors de la création du prospect:', error);
          this.router.navigate(['/checkout']);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }
}
